module.exports = __webpack_public_path__ + "img/bidbarg.7989e97.png";